module.exports = __webpack_public_path__ + "static/media/provider-awcmsexy.a571de0b.png";